var Constructor = require('js/vendor/constructor');
var Backbone = require('backbone');
var _ = require('underscore');
var Promise = require('js/vendor/promise');

require('js/vendor/backbone/queryparameters'); // Use globaly

// Force use of named parameters
Backbone.Router.namedParameters = true;

// Some consts
var MODULE_SEPARATOR = ':';
var ACTION_SEPARATOR = '.';
var PARAM_VAR = '$';

var Resolution = Constructor.extend();

Resolution.prototype.initialize = function(userRes) {
  this.module = userRes.module || null;
  this.controller = userRes.controller || 'index';
  this.action = userRes.action || 'index';
  this.params = userRes.params || {};
};

var Router = Constructor.extend().mixes(Backbone.Events);

/**
 * Ref to a router Resolution constructor
 */
Router.Resolution = Resolution;

/**
 * Hold an instance of Backbone router
 */
Router.prototype.router = null;

/**
 * Routes object
 */
Router.prototype.routes = null;

/**
 * Stored parameter object to pass to next routing
 */
Router.prototype.storedParams = null;

/**
 * Hold the current resolution object
 */
Router.prototype.res = null;

/**
 * Hold the last res before change
 */
Router.prototype.lastRes = null;

/**
 * What is the current url path?
 */
Router.prototype.fragment = '';

/**
 * What was the last url path before current?
 */
Router.prototype.lastFragment = '';

var generateRouteFunction = function(target) {
  return function(params) {

    // Merge stored params and then set them to null
    params = _.extend({}, params, this.storedParams);
    this.storedParams = null;

    var tmpTarget = target;

    // Should we call a resolver method?
    if (_.isFunction(tmpTarget)) {
      var resolved = tmpTarget.call(this, params);
      if (resolved instanceof Promise) {
        resolved.then(this.resolve, this);
      } else {
        this.resolve(resolved);
      }
      // Just a string target
    } else {

      // Parse named parameters in target
      _.each(params, function(value, name) {
        tmpTarget = tmpTarget.replace(PARAM_VAR + name, value);
      });

      // Replace any remaining $var with null to declare it as an unresovled
      tmpTarget = tmpTarget.replace(/\$([A-Za-z])*/g, 'null');

      var splitTarget = tmpTarget.split(MODULE_SEPARATOR);
      var modulePath = splitTarget.length > 1 ? splitTarget[0] : null;
      var deModularisedTarget = splitTarget.length > 1 ? splitTarget[1] : splitTarget[0];
      var splitDeModularisedTarget = deModularisedTarget.split(ACTION_SEPARATOR);
      var controllerPath = splitDeModularisedTarget[0];
      var action = splitDeModularisedTarget[1] || null;

      this.resolve(this.newResolution({
        module: modulePath == 'null' ? null : modulePath,
        controller: controllerPath == 'null' ? null : controllerPath,
        action: action == 'null' ? null : action,
        params: params,
        name: 'hi',
      }));
    }

  };
};

Router.prototype.initialize = function(routes) {
  var parsedRoutes = {};

  _.each(routes, function(target, route) {
    parsedRoutes[route] = generateRouteFunction(target).bind(this);
  }, this);

  this.routes = parsedRoutes;

  this.router = new Backbone.Router({ routes: this.routes });
};

Router.prototype.resolve = function(resolution) {
  // Store res and last res
  this.lastRes = this.res;
  this.res = resolution;

  // Store fragment and last fragment
  this.lastFragment = this.fragment;
  this.fragment = Backbone.history.fragment;

  // Let listeners know
  this.trigger('resolve', resolution);
};

Router.prototype.newResolution = function(userRes) {
  return new Resolution(userRes);
};

/**
 * Force a backbone history navigation (where trigger is true by default)
 * TODO: Allow passing data which is used upon routing and put into params
 */
Router.prototype.navigate = function(fragment, options) {
  options = _.extend({ trigger: true }, options);

  // If we are routing and passing param data
  if (options.params) {
    this.storeParams(options.params);
  }

  const shouldAllowToNavigateAway = (alerts) => {
    for (var key in this.preventNavigateAway) {
      const alert = alerts[key];
      if (alert.isConditionMet()) {
        return window.confirm(alert.message);
      }
    }
    return true;
  };

  if (
    !this.preventNavigateAway ||
    shouldAllowToNavigateAway(this.preventNavigateAway)
  ) {
    // navigate is called twice, so we want to disable to alert only for the first one
    // otherwise the alert set in the component (componentDidMount) will be removed
    if (!options.replace) {
      this.disableBeforeLeavingAlert();
    }
    this.trigger('navigating');
    Backbone.history.navigate(fragment, options);
  }
};

/**
 * Sets a message that will be shown before the user abandons the current page
 * isConditionMet defines whether or not the alert will appear
 */
Router.prototype.setBeforeLeavingAlert = function(message, isConditionMet = () => true) {
  let newId = Date.now().toString(36);
  if (!this.preventNavigateAway) {
    this.preventNavigateAway = {};
  }
  this.preventNavigateAway[newId] = { message, isConditionMet };
  return newId;
};

/**
 * Disable the message that will be shown before the user abandons the current page
 */
Router.prototype.disableBeforeLeavingAlert = function(id) {
  if (this.preventNavigateAway) {
    if (id) {
      delete this.preventNavigateAway[id];
    } else {
      this.preventNavigateAway = null;
    }
  }
};


/**
 * Store params for the next routing to use
 * TODO: There is probably a much safer way of doing this and just passing through a single route chain rather than store globally for potentially any route to catch later
 */
Router.prototype.storeParams = function(params) {
  this.storedParams = params || {};
};

/**
 * Returns current route
 */
Router.prototype.getCurrentRoute = function() {
  return Backbone.history.getFragment().split('?')[0];
};

module.exports = Router;

// M/C/A mapping = 'module:controller.action'

//paths: {'community': ''}


//What the dispatcher/app/whatever needs to know
//{
//	module: '',
//	controller: 'index',
//	action: 'index',
//	params: []
//}



// WEBPACK FOOTER //
// ./app/assets/js/lib/router.js